/**
 * GridModeToggle.jsx
 * ──────────────────
 * Segmented control toggling between Detail and Grid modes.
 * Visible for all TMG roles, hidden for supplier roles.
 */

import React from 'react';
import { useUser } from '../../shared/context/UserContext';

export default function GridModeToggle({ activeMode, onChange }) {
  const { userProfile } = useUser();
  const role = userProfile?.role;

  // Supplier roles and unknown: render nothing
  if (!role || ['SUPPLIER_USER', 'SUPPLIER_MANAGER'].includes(role)) return null;

  return (
    <div className="grid-mode-toggle">
      <button
        type="button"
        className={`grid-mode-toggle-btn${activeMode === 'detail' ? ' active' : ''}`}
        onClick={() => onChange('detail')}
      >
        Detail
      </button>
      <button
        type="button"
        className={`grid-mode-toggle-btn${activeMode === 'grid' ? ' active' : ''}`}
        onClick={() => onChange('grid')}
      >
        Grid
      </button>
    </div>
  );
}
